export default __webpack_public_path__ + "static/media/Acen-icon.8fef23fd.png";